module.exports = __webpack_public_path__ + "img/zfb.9710db5a.png";